import { useCallback, useEffect, useState } from 'react';

import { skipToContent } from '@/helpers/common';
import usePublicTranslation from '@/hooks/usePublicTranslation';

import styles from './styles.module.scss';

const FooterActions = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  const t = usePublicTranslation();

  const scrollListener = useCallback(() => {
    if (window.scrollY > 500) {
      setShowTopBtn(true);
    } else {
      setShowTopBtn(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [scrollListener]);

  return (
    <div className={styles.footerActions}>
      <div className={styles.data}>
        <div />
        {showTopBtn && (
          <div className={styles.top}>
            <button onClick={skipToContent}>
              <span className={styles.text}>{t('general.back_to_top')}</span>
              <i className="fasl fa-arrow-up-to-line" role="img" aria-hidden={true} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FooterActions;
